import { ISettlementItemData } from 'types/order/fees/ISectionData';
import { ILineItemProps } from './ILineItemProps';
import { useGetCurrentSection } from './useGetCurrentSection';
import { useMemo } from 'react';
import { sortBySequence } from '../organizeFees';
import { useGetCurrentSectionDefinition } from './useGetCurrentSectionDefinition';

/**
 * This is used after the initial page load, so no need to worry about refetching.
 * @param orderId The order ID that we want the line item of
 * @param lineItemId The line item id that we want from it (optional)
 */
export const useGetCurrentLineItem = (props: ILineItemProps) => {
  const lineItem = useGetCurrentLineItemBase(props);
  const items = useGetCurrentSectionDefinition(props);

  const result = useMemo(() => {
    if (!lineItem) {
      return undefined;
    }
    const result: ISettlementItemData = {
      ...lineItem,
      statementFees: lineItem.statementFees.toSorted(
        sortBySequence(items?.statementSettlementAndFeeCategoryDefinitions ?? [])
      ),
    };
    return result;
  }, [lineItem, items]);
  return result;
};
const useGetCurrentLineItemBase = (props: ILineItemProps) => {
  const { currentSection } = useGetCurrentSection(props);

  const { lineItemId } = props;

  if (!lineItemId) {
    return undefined;
  }

  if (currentSection) {
    return currentSection.statementSettlementItems.find((t) => t.settlementStatementItemId === lineItemId);
  }

  return undefined;
};
